import React, { useEffect } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { recordTimePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { NO_DATE } from '@/pages/opinion/constants';
import {
  recordTimesMap,
  recordTimesOptions,
} from '../../constants/recordTimes';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function RecordTimesSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
}: SingleCommonType) {
  const {
    selects: recordTimesSelects,
    setSelects: setRecordTimesSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'record_times',
    options: recordTimesOptions.map((item) => item.value),
  });

  const { formatMessage } = useLanguage();

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'recordTimes',
      commonBackInfo(
        { record_times: recordTimesSelects },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [recordTimesSelects, formatMessage]);

  return (
    <div className={`record-times-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={recordTimePlaceholder[lang]}
        onClear={() => setRecordTimesSelects([])}
        buttonItemRender={(item: string) =>
          formatMessage({ id: recordTimesMap[item] || NO_DATE.EMPTY })
        }
        showNumber={3}
        selectOptionsInfo={[recordTimesSelects, setRecordTimesSelects]}
        options={recordTimesOptions}
        pointKey={FilterButtonPoint.recordTimes}
      ></CustomSelect>
    </div>
  );
}
